import Button from "../components/Button";
import Input from "../components/Input";
import Close from "../assets/images/X.svg";
import loginBg from "../assets/images/login-bg.svg";
import loginBg2 from "../assets/images/login-bg.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginEmail from "./LoginEmail";
import LoginVerify from "./LoginVerify";
import { useAuth } from "../contexts/AuthContext"; // Import useAuth to access context
import { useOtp } from "../contexts/OtpContext";
import { useDispatch, useSelector } from "react-redux";
import { sendOTPAsync } from "../lib/service/otp/sendOTPSlice";
import { verifyOTPAsync } from "../lib/service/otp/verifyOTPSlice";
import Spinner from "../components/Spinner";
import toast from "react-hot-toast";

function Login({ onClick }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(""); // Initialize state for error
  const [showModal, setShowModal] = useState("login"); // State to control which modal is visible
  const { login } = useAuth(); // Track if user is logged in
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendOTPState = useSelector((state) => state.sendOTP);
  const [isCloseLoaded, setIsCloseLoaded] = useState(false);
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  const verifyOTPState = useSelector((state) => state.verifyOTP);

  //   const navigate = useNavigate();
  const handleInputChange = (event) => {
    setEmail(event.target.value);
    setError("");
  };
  const { otp } = useOtp();
  const otpString = Object.values(otp).join("");

  const handleButtonClick = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      toast.error("Please enter a valid email address.")
    } else if (email) {
      // Dispatch sendOTPAsync if email is valid
      dispatch(sendOTPAsync({ email }))
        .unwrap()
        .then(() => {
          login();
          navigate("/verification", { state: { status: true } });
          toast.success("Logged Successfully")
          onClick();
        })
        .catch((error) => {
          console.error("Error sending OTP:", error);
          // setError(error?.message);
          navigate("/reservation", { state: { status: "error" } });
          onClick();
        });
    } else {
    }
  };

  const divStyle = {
    backgroundImage: `url(${loginBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain", // Ensures the full image is visible without cropping
    backgroundPosition: "center", // Centers the image in the div
    display: "inline-block",
  };

  return (
    <div className="leap-relative ">
      <img
        src={loginBg2}
        alt="loginBg"
        className="leap-h-[10rem] md:leap-h-[20rem]  leap-w-[45rem]  md:leap-w-[32rem] xl:leap-w-[55rem]"
        onLoad={() => setIsLogoLoaded(true)}
      />

      {isLogoLoaded ? (
        <>
          <div className="leap-scale-75 md:leap-scale-105  leap-absolute leap-top-1/2 -leap-translate-x-[50%] -leap-translate-y-[70%] leap-left-1/2 leap-gap-20">
            <h1 className="custom-white-border  md:leap-mb-16 leap-text-[30px] sm:leap-text-[45px] leap-my-3 leap-font-bold  leap-text-center leap-uppercase leap-text-white">
              Login
            </h1>
            {showModal === "login" && (
              <LoginEmail
                email={email}
                error={error}
                handleInputChange={handleInputChange}
                handleButtonClick={handleButtonClick}
              />
            )}
          </div>
          <button className="" onClick={onClick}>
            <img
              src={Close}
              alt="Close"
              className="leap-absolute  leap-top-[8px]  leap-left-[8px]  leap-w-6 leap-h-6  md:leap-w-8 md:eap-h-8"
              loading="lazy"
            />
          </button>
        </>
      ) : null}
    </div>
  );
}

export default Login;
